document.addEventListener("DOMContentLoaded", function () {
  const searchToggle = document.querySelector(".header__search-toggle");
  const searchInput = document.querySelector("#search-input");
  const searchClose = document.querySelector(".search-container__close-button");
  const body = document.body;

  const SEARCH_ACTIVE = "search-active";

  searchToggle.addEventListener("click", function (e) {
    if (body.classList.contains(SEARCH_ACTIVE)) {
      body.classList.remove(SEARCH_ACTIVE);
    } else {
      body.classList.add(SEARCH_ACTIVE);
      // wait until the input is in the DOM before focusing
      setTimeout(() => {
        searchInput.focus();
      }, 400);
    }

    const menuToggleActive = document.querySelector(
      ".header__mobile-menu-toggle.active"
    );
    const activeMobileMenus = document.querySelectorAll(
      ".mobile-menu__wrapper.active"
    );

    menuToggleActive && menuToggleActive.classList.remove("active");

    if (body.classList.contains("no-scroll")) {
      body.classList.remove("no-scroll");
    }

    if (activeMobileMenus && activeMobileMenus.length) {
      activeMobileMenus.forEach(function (activeMenu) {
        activeMenu.classList.remove("active");
      });
    }
  });

  searchClose.addEventListener("click", function (e) {
    if (body.classList.contains(SEARCH_ACTIVE)) {
      body.classList.remove(SEARCH_ACTIVE);
    }
  });
});
